



































































import { Mixins, Component, Watch, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import * as I from '@/interfaces';
import AxMonitorGrid from '@/components/layout/AxMonitorGrid.vue';
import { HubConnectionBuilder, LogLevel, HubConnection } from '@microsoft/signalr';

class WebsocketState {
  isDestroyed: boolean;
  isConnection: boolean;
  connection!: HubConnection;
  listGridDoor!: AxMonitorGrid[];
  listGridSensor!: AxMonitorGrid[];
  constructor() {
    this.isDestroyed = false;
    this.isConnection = false;
  }

  Delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async Connect() {
    if (this.isDestroyed) return;
    const { hostname } = window.location;
    //const baseURL = process.env.NODE_ENV === 'development' ? `https://${hostname}:44393` : '';
    const baseURL = process.env.NODE_ENV === 'development' ? `https://localhost:44393` : '';
    // 기존 이벤트값 초기화
    this.listGridDoor.forEach(door => {
      door.listEvent = []; // 빈 배열로 초기화
    });
    // 이미 연결이 열려 있는지 확인
    if (this.isConnection === true) {
      console.log('Connection is already open');
      return;
    }
    this.connection = new HubConnectionBuilder()
      .withUrl(baseURL + '/EventHub', {
        accessTokenFactory: () => 'test'
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();
    // SignalR 연결 이벤트 처리
    this.connection.onclose(() => {
      this.isConnection = false;
      console.log('SignalR 연결이 끊어졌습니다. 다시 연결을 시도합니다.');
      this.Connect(); // 연결 재시도
    });
    this.connection
      .start()
      .then(() => {
        this.SetEvent();
        this.GetDoorStatus();
        this.isConnection = true;
        console.log('SignalR 연결 성공');
      })
      .catch(async (err: Error) => {
        console.error('SignalR 연결 실패:', err);
      });
  }

  SetEvent() {
    this.connection.on('sendDoorEvent', (event: I.MonitorSimpleEvent) => {
      this.listGridDoor.forEach(door => {
        if (door.door.doorID === event.doorID) {
          console.log('event:' + event);
          door.AddEvent(event);
        }
      });
    });
    this.connection.on('DoorConnectionChanged', (status: I.DoorConnectionStatus) => {
      this.listGridDoor.forEach(door => {
        if (door.door.doorID === status.doorId) {
          door.state.isConnected = status.connected;
        }
      });
    });
    this.connection.on('DoorStatus', (status: I.DoorStatus) => {
      this.listGridDoor.forEach(door => {
        if (door.door.doorID === status.doorId) {
          door.state.isConnected = status.connected;
          door.state.doorStatus = status.doorStatus;
        }
      });
    });
    this.connection.on('DoorStatusChange', (status: I.SLAEvent) => {
      this.listGridDoor.forEach(door => {
        if (door.door.doorID === status.doorId) {
          door.state.doorStatus = status.eventCode;
        }
      });
    });
    this.connection.on('SensorEvent', (status: I.SensorEvent) => {
      this.listGridSensor.forEach(sensor => {
        if (sensor.sensor.sensorID === status.SensorId) {
          sensor.state.doorStatus = status.EventCode;
        }
      });
    });
    this.connection.on('DoorControlResult', (account, result, msg) => {
      console.log(account);
      console.log(result);
      console.log(msg);
      // if (account == 'administrator' && result == false) {
      //   this.EventBus.$emit('ShowModalText', {
      //     text: msg,
      //     title: '오류'
      //   });
      // }
    });
  }

  GetDoorStatus() {
    const listDoor: number[] = [];
    this.listGridDoor.forEach(door => {
      listDoor.push(door.door.doorID);
    });

    console.log('ddoor' + this.listGridDoor);

    this.connection
      .invoke('GetDoorStatus', listDoor)
      .then(() => {
        //this.SetDoorStatus();
      })
      .catch((err: Error) => console.error(err.toString()));
  }

  onDoorControl(groupid: number, doorid: number, controlcode: number) {
    console.log('monitoring control: doorid' + doorid);
    this.connection
      .invoke('DoorControl', 'administrator', groupid, doorid, controlcode)
      .then(() => {
        // this.SetDoorStatus();
      })
      .catch((err: Error) => console.error(err.toString()));
  }

  SetDoorStatus() {
    console.log('a');
  }

  SetWebSocketEvent() {
    this.connection.onclose(() => {
      console.log('ws disconnected!');
      // this.EventBus.$emit('WebSocketDisconnected');
      // this.ConnectWebSocket();
    });
    // this.RecvPacket(this.connection);
  }
}

@Component
export default class Monitoring extends Mixins(AxPage) {
  @Ref()
  listGridDoor!: AxMonitorGrid[];

  @Ref()
  listGridSensor!: AxMonitorGrid[];

  @Ref()
  isConnection!: boolean;

  onItemsCollectionChanged() {
    if (this.groupNo !== this.latestInfo.groupId) {
      // console.log('chg' + this.latestInfo.groupId);
      if (this.isConnection === false) {
        console.log('시작');
        this.prepare();
      } else {
        this.websocketState.isDestroyed = true;
        this.websocketState.connection.stop();
        this.prepare();
      }
    }
  }

  onOpenClick(doorid: number, controlcode: number) {
    console.log('monitoring: doorid' + doorid);
    this.websocketState.onDoorControl(this.latestInfo.groupId, doorid, controlcode);
  }

  doorAllOpen(controlcode: number) {
    console.log('doorlist');
    console.log(this.listGridDoor);
    for (const idx in this.listGridDoor) {
      const doorid = this.listGridDoor[idx].door.doorID;
      this.websocketState.onDoorControl(this.latestInfo.groupId, doorid, controlcode);
    }
  }

  onOpenAllClick(itype: number, controlcode: number) {
    switch (itype) {
      case 1:
      case 2:
      case 3:
        this.doorAllOpen(controlcode);
        break;
      case 4:
        break;
    }
  }

  onWebSocketCheck() {
    console.log('소켓상태:', this.websocketState);
    if (this.websocketState.connection.connectionStarted === false) {
      this.websocketState.Connect();
    }
  }

  calculateGridLineCount() {
    if (this.listDoor.length <= 16) {
      this.gridLineCount = 16;
    } else {
      this.gridLineCount = Math.ceil(this.listDoor.length / 4) * 4;
    }
  }

  mounted() {
    setInterval(() => this.onItemsCollectionChanged(), 1000);
    //setInterval(() => this.onWebSocketCheck(), 5000);
  }

  beforeDestroy() {
    console.log('파괴', '소켓연결 끊어졌습니다.');
    this.websocketState.isDestroyed = true;
    this.websocketState.connection.stop();
  }

  monitorGroup!: I.MonitorGroup;
  listDoor: I.MonitorDoor[] = [];
  listSensor: I.MonitorSensor[] = [];
  websocketState!: WebsocketState;
  groupNo: number;
  gridLineCount = 16;

  async prepare() {
    if (this.isConnection === true) {
      console.log('prepare: 이미 연결되어 있습니다.');
      return;
    }
    // console.log('group' + this.latestInfo.groupId + this.latestInfo.controller);
    if (this.latestInfo.controller === 'MONITOR' && this.latestInfo.groupId !== 0) {
      this.setLoading(true);
      this.groupNo = this.latestInfo.groupId;
      const baseData = await this.getMonitoringInfo();
      if (baseData) {
        this.monitorGroup = baseData;
        this.listDoor = baseData.listDoor;
        console.log(baseData.listDoor);
        this.listSensor = baseData.listSensor;
        this.calculateGridLineCount();
        this.ConnectWebSocket();
      }
      this.setLoading(false);
    }
  }
  async getMonitoringInfo() {
    //console.log('group' + this.groupId);
    this.groupNo = this.latestInfo.groupId;
    const result = await this.API.call.monitor.groupInfo(this.latestInfo.groupId);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async ConnectWebSocket() {
    this.websocketState = new WebsocketState();
    await this.$nextTick(() => {});
    this.websocketState.listGridDoor = this.listGridDoor;
    this.websocketState.listGridSensor = this.listGridSensor;
    this.websocketState.Connect();
  }
  get countEmpty() {
    return 16 - this.listSensor.length - this.listDoor.length;
  }

  // $destroy() {
  //   if (this.websocketState) {
  //     this.websocketState.isDestroyed = true;
  //   }
  // }
}
